// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconArlusd } from "../../../icons/full/build/icon-arlusd.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const ArlusdIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconArlusd.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  ArlusdIcon.displayName = 'ArlusdIcon';
}

export default ArlusdIcon;